"use client";
import { useMemoizedFn } from "ahooks";
import { message } from "antd";
import { useEffect } from "react";
import { cn } from "utils";
import { ospThemes } from "../ospThemes";
import { JsSdkEventEmitInstance } from "../utils/JsSdkEventEmit";
import { UiSvgs } from "../svgs";
import { OptionType } from "./types";
import { ToastEventName } from "./toast";
import { useStyles } from "./styles";

export const OspToastView = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { styles, cx } = useStyles();

  const showToast = useMemoizedFn((options: OptionType) => {
    const { type, content, key, duration, action } = options;
    const hasAction = Boolean(action);
    const iconSize = hasAction ? 20 : 24;
    const icon =
      type !== "info" ? (
        <UiSvgs
          name={
            type === "success"
              ? "successCircle"
              : type === "error"
                ? "errorCircle"
                : type === "warning"
                  ? "warningCircle"
                  : "successCircle"
          }
          size={iconSize}
          fill={
            type === "success"
              ? ospThemes.colors.content_accent1_primary
              : type === "error"
                ? ospThemes.colors.content_accent2_primary
                : type === "warning"
                  ? ospThemes.colors.content_accent3_primary
                  : ospThemes.colors.content_accent1_primary
          }
        ></UiSvgs>
      ) : (
        <div></div>
      );

    const handleActionClick = () => {
      action?.onClick();
      if (key) {
        messageApi.destroy(key);
      }
    };

    return messageApi.open({
      type,
      content: hasAction ? (
        <div className="flex w-full min-w-0 flex-1 items-center justify-start gap-2">
          <span className="body_m min-w-0 flex-1 text-left leading-[20px] text-content_primary">
            {content}
          </span>
          <button
            type="button"
            className="button_s shrink-0 cursor-pointer self-center text-content_accent4_primary"
            onClick={handleActionClick}
          >
            {action?.label}
          </button>
        </div>
      ) : (
        <div
          className={cn("body_m text-content_primary", {
            "ml-2": type !== "info",
          })}
        >
          {content}
        </div>
      ),
      icon: hasAction ? (
        <span className="inline-flex shrink-0">{icon}</span>
      ) : (
        icon
      ),
      key,
      className: cx(
        styles.toastContainer,
        hasAction && styles.toastContainerAction,
      ),
      duration: duration ?? (hasAction ? 5 : undefined),
    });
  });
  useEffect(() => {
    return JsSdkEventEmitInstance.addEventListener<OptionType>(
      ToastEventName,
      showToast,
    );
  }, [showToast]);


  return <>{contextHolder}</>;
};
